import { customWebFonts } from '@src/utility/general';
import { uniqBy } from 'lodash';

import type VideoCreatorStore from '@src/stores/VideoCreatorStore';
import type { BrandingCustomFont } from '@src/types.ts/story';

const getFontId = (font: BrandingCustomFont) =>
  `${font.fontFamily}-${font.postScriptName}`;

export default class CustomFontsService {
  protected videoCreator: VideoCreatorStore;

  constructor(videoCreator: VideoCreatorStore) {
    this.videoCreator = videoCreator;
  }

  getCustomFontsSource(initialSource: Record<string, any>) {
    const customFonts = uniqBy(
      this.videoCreator.organization?.branding?.customFonts?.filter(
        f => !f.archivedAt,
      ),
      f => getFontId(f),
    );

    let fontsConfig: {
      family: string;
      weight: number;
      style: string;
      source: string;
    }[] = customWebFonts;

    if (customFonts && customFonts.length) {
      fontsConfig = [
        ...fontsConfig,
        ...customFonts.map(font => ({
          family: font.postScriptName,
          weight: font.usWeightClass,
          style: font.style,
          source: font.source,
        })),
      ];
    }

    return {
      ...initialSource,
      fonts: uniqBy(
        [...(initialSource?.fonts || []), ...fontsConfig],
        f => `${f.family}|${f.weight}|${f.style}`,
      ),
    };
  }
}
